import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Jokofix
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#vuokraus" className="page-scroll">
                Vuokrattavat
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Tietoa
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Palvelut
              </a>
            </li>
            <li>
              <a href="#facebook" classname="page-scroll">
                Facebook
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Ota yhteyttä
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
